@import 'styles/mixins';
@import 'styles/variables';

.scrollWrapper {
  overflow: auto;
  display: flex;
  flex-direction: row-reverse;
  overflow-y: hidden;

  &.v2 {
    .divider {
      color: $grey-20;
      margin: 0 2px;
    }

    .projectLink,
    .projectTitle {
      padding: 2px 2px 2px 0px;
    }

    .folderButtonText {
      padding: 6px 4px;
    }
  }
}

.rootBreadcrumb {
  stroke: none !important;
}

.breadcrumbs {
  display: flex;
  align-items: center;

  li.breadcrumb {
    @include ui-md-text;

    align-items: center;
    color: $gray-50;
    display: inline-flex;
    white-space: pre;

    &:last-child {
      @include ui-md-bold;

      color: $almanac-black;
    }

    .link {
      align-items: center;
      color: inherit;
      display: inline-flex;
    }
  }

  .breadcrumb {
    @include md-regular;

    align-items: center;
    border-radius: 4px;
    color: $grey-50;
    display: flex;

    svg {
      fill: transparent !important;
      margin-right: 8px;
      stroke: $grey-30;
      min-width: 16px;
      min-height: 16px;
    }
  }

  .separator {
    fill: $grey-20;
  }

  .projectLink {
    @include md-regular;

    color: $grey-40;
    cursor: pointer;
    padding: 8px;

    @media (max-width: $mediumDevicesMinWidth) {
      max-width: 100px;
    }

    &:hover {
      background-color: $grey-5;
    }
  }

  .groupLink {
    align-items: center;
    display: flex;
    color: $gray-40;
    cursor: pointer;

    &.active {
      @include ui-md-bold;
      color: $gray-90;
    }

    svg {
      margin-right: 8px;
    }
  }

  .groupContainer {
    align-items: center;
    display: flex;

    .favoriteButton {
      margin-left: 8px;
    }
  }

  .projectTitle {
    @include md-regular;

    align-items: center;
    color: $gray-90;
    display: flex;
    padding: 8px;

    svg {
      min-height: 16px;
      min-width: 16px;
      flex-shrink: 0;
    }

    .favoriteButtonContainer {
      display: inline-block;
      min-height: 16px;
      min-width: 16px;

      svg {
        margin: 0;
      }
    }
  }
}

.breadcrumbContainer {
  align-items: center;
  display: flex;
}

.hiddenBreadcrumbOption {
  opacity: 0;
  transition: opacity 200ms;

  &.visible {
    opacity: 1;
    transition: opacity 200ms;
  }
}

.folderMenuIcon {
  svg {
    margin-right: 0 !important;
  }
}
